export const DISC_LETTER_NUMBER = 76884;

// Warmup group sentinel: sorts after every real config letter but before the
// discard group, so config lists read A..N, Warmup, Discards. The decoded
// letters are meaningless — special groups are displayed by role name, never
// by letter (see utils/configRole.ts for the helpers to use).
export const WARM_LETTER_NUMBER = DISC_LETTER_NUMBER - 100;

// Any letter_number at or above this belongs to a special (non-lettered)
// config group. Prefer the configRole helpers over comparing this directly.
export const SPECIAL_CONFIG_THRESHOLD = WARM_LETTER_NUMBER;
